import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { addNews } from 'src/helpers/api';
import { addToast } from 'src/components/Toast';
import AdminNewsForm, {
  IAdminNewsFormSubmitValues
} from './components/NewsForm';
import { useAdminNews } from './Context';

const AdminNewsCreate = (props: RouteComponentProps) => {
  const news = useAdminNews();
  const handleCreate = async (values: IAdminNewsFormSubmitValues) => {
    try {
      const addedNews = await addNews(values);
      addToast({ type: 'info', message: 'Nyheden er oprettet' });
      news.fetchList();
      props.history.replace(`/cms/nyheder/${addedNews.id}`);
    } catch (error) {
      addToast({ type: 'error', message: 'Der opstod en fejl' });
    }
  };

  return (
    <div className="has-background-white relative flex-1 p-14">
      <h2 className="uppercase font-light f4 mt-0 mb-5">Opret nyhed</h2>
      <AdminNewsForm
        onCancel={() => props.history.push('/cms/nyheder')}
        onSubmit={handleCreate}
      />
    </div>
  );
};

export default AdminNewsCreate;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/AdminNews/Create.tsx